import { render, staticRenderFns } from "./manage-event-subscriptions.vue?vue&type=template&id=9c855456&"
import script from "./manage-event-subscriptions.vue?vue&type=script&lang=ts&"
export * from "./manage-event-subscriptions.vue?vue&type=script&lang=ts&"
import style0 from "./manage-event-subscriptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports